import { escapeHtml, truncate } from '../utils';

export interface ListItemConfig {
  id: string;
  avatarUrl: string | null;
  avatarFallbackIcon: string;
  title: string;
  metaHtml?: string;
  preview: string;
  unreadCount?: number;
  cssClass?: string;
}

export function renderListItem(config: ListItemConfig): string {
  const avatarContent = config.avatarUrl
    ? `<img src="${config.avatarUrl}" alt="${escapeHtml(config.title)}" />`
    : `<i class="fas fa-${config.avatarFallbackIcon}"></i>`;

  const unreadClass = config.unreadCount && config.unreadCount > 0 ? ' unread' : '';
  const extraClass = config.cssClass ? ` ${config.cssClass}` : '';

  const unreadBadge = config.unreadCount && config.unreadCount > 0
    ? `<span class="unread-badge">${config.unreadCount}</span>`
    : '';

  return `
    <div class="list-item friend-item${unreadClass}${extraClass}" id="${config.id}">
      <div class="avatar avatar-md friend-avatar">
        ${avatarContent}
      </div>
      <div class="friend-main">
        <div class="friend-top-row">
          <span class="friend-name truncate">${escapeHtml(config.title)}</span>
          ${unreadBadge}
          <div class="friend-meta">
            ${config.metaHtml || ''}
          </div>
        </div>
        <div class="friend-bottom-row">
          <span class="friend-preview truncate">${escapeHtml(truncate(config.preview, 200))}</span>
        </div>
      </div>
      <div class="friend-chevron">
        <i class="fas fa-chevron-right"></i>
      </div>
    </div>
  `;
}
